import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, RouterProvider} from 'react-router-dom';
import MyDropdownBikeSize from '../../../UI/dropdown/MyDropdownBikeSize';
import MyDropdownBrend from '../../../UI/dropdown/MyDropdownBrend';
import './../../../Styles/Main/RentalPage/RentalSelectedBike.scss';
import RentalBikeCard from './RentalBikeCard';
import { aluminiumBikes, carbonBikes, cityBikes, mtbBikes, bikesBrend, bikesFrameSize, rentalRequestRoute } from './../../../Constant/index';
import { useState } from 'react';
import MyButton from '../../../UI/button/MyButton';
import { useEffect, useContext } from 'react';
import {SelectedBike} from './../../../Constant/context'

function RentalSelectedBike({setChangeChoise, ...props }) {

   const [selectedOptionSize, setSelectedOptionSize] = useState(bikesFrameSize[0]);
   const [selectedOptionBrend, setSelectedOptionBrend] = useState(bikesBrend[0]);
   const [hideSelectionBrend, setHideSelectionBrend] = useState(false)
   const [firstSorting, setFirstSorting] = useState('');
   const [finalSorting, setFinalSorting] = useState(props.selectedTypeOfBike);

   const { selectedBikeGlobal, setSelectedBikeGlobal, arrayOfBikes, setArrayOfBikes, selectedDateGlobal, setSelectedDateGlobal } = useContext(SelectedBike)

   useEffect(() => {
      if (!props.changeChoise) {
         setFinalSorting(props.selectedTypeOfBike)
         setSelectedOptionSize(bikesFrameSize[0])
         setSelectedOptionBrend(bikesFrameSize[0])
      }
   })

   const takeBikeNumber = (value, state) => {
      if (value.slice(0, 1) === '1') {
         let globalBike = { ...selectedBikeGlobal }
         for (let item in aluminiumBikes) {
            if (aluminiumBikes[item].number === value && aluminiumBikes[item].state === false) {
               aluminiumBikes[item].state = true;
               globalBike.name = `${aluminiumBikes[item].typeBike} ${aluminiumBikes[item].fullName}`;
               globalBike.price = aluminiumBikes[item].price;
               globalBike.picture = aluminiumBikes[item].image;
               globalBike.selected = aluminiumBikes[item].state;
               globalBike.number = value;
               setSelectedBikeGlobal(globalBike);
               setArrayOfBikes([...arrayOfBikes, globalBike]);
            } else if (aluminiumBikes[item].number === value && aluminiumBikes[item].state === true) {
               let globalBikeRemove = [...arrayOfBikes]
               console.log(globalBikeRemove);
               globalBikeRemove = globalBikeRemove.filter((item) => item.number !== value)
               setArrayOfBikes(globalBikeRemove);
               aluminiumBikes[item].state = false;
            }
         }
      }
      if (value.slice(0, 1) === '2') {
         let globalBike = { ...selectedBikeGlobal }
         for (let item in carbonBikes) {
            if (carbonBikes[item].number === value && carbonBikes[item].state === false) {
               carbonBikes[item].state = true;
               globalBike.name = `${carbonBikes[item].typeBike} ${carbonBikes[item].fullName}`;
               globalBike.price = carbonBikes[item].price;
               globalBike.picture = carbonBikes[item].image;
               globalBike.selected = carbonBikes[item].state;
               globalBike.number = value;
               setSelectedBikeGlobal(globalBike);
               setArrayOfBikes([...arrayOfBikes, globalBike]);
            } else if (carbonBikes[item].number === value && carbonBikes[item].state === true) {
               let globalBikeRemove = [...arrayOfBikes]
               console.log(globalBikeRemove);
               globalBikeRemove = globalBikeRemove.filter((item) => item.number !== value)
               setArrayOfBikes(globalBikeRemove);
               carbonBikes[item].state = false;
            }
         }
      }
      if (value.slice(0,1) === '3') {
         let globalBike = { ...selectedBikeGlobal }
         for (let item in cityBikes) {
            if (cityBikes[item].number === value && cityBikes[item].state === false) {
               cityBikes[item].state = true;
               globalBike.name = `${cityBikes[item].typeBike} ${cityBikes[item].fullName}`;
               globalBike.price = cityBikes[item].price;
               globalBike.picture = cityBikes[item].image;
               globalBike.selected = cityBikes[item].state;
               globalBike.number = value;
               setSelectedBikeGlobal(globalBike);
               setArrayOfBikes([...arrayOfBikes, globalBike]);
            } else if (cityBikes[item].number === value && cityBikes[item].state === true) {
               let globalBikeRemove = [...arrayOfBikes]
               console.log(globalBikeRemove);
               globalBikeRemove = globalBikeRemove.filter((item) => item.number !== value)
               setArrayOfBikes(globalBikeRemove);
               cityBikes[item].state = false;
            }
         }
      }
      if (value.slice(0,1) === '4') {
         let globalBike = { ...selectedBikeGlobal }
         for (let item in mtbBikes) {
            if (mtbBikes[item].number === value && mtbBikes[item].state === false) {
               mtbBikes[item].state = true;
               globalBike.name = `${mtbBikes[item].typeBike} ${mtbBikes[item].fullName}`;
               globalBike.price = mtbBikes[item].price;
               globalBike.picture = mtbBikes[item].image;
               globalBike.selected = mtbBikes[item].state;
               globalBike.number = value;
               setSelectedBikeGlobal(globalBike);
               setArrayOfBikes([...arrayOfBikes, globalBike]);
            } else if (mtbBikes[item].number === value && mtbBikes[item].state === true) {
               let globalBikeRemove = [...arrayOfBikes]
               console.log(globalBikeRemove);
               globalBikeRemove = globalBikeRemove.filter((item) => item.number !== value)
               setArrayOfBikes(globalBikeRemove);
               mtbBikes[item].state = false;
            }
         }
      }
   }

   const addSelectedBike = () => {
      let sum = 0;
      for (let item in arrayOfBikes) {
         sum = sum + parseInt(arrayOfBikes[item]['price'])
      }
      let globalDate = { ...selectedDateGlobal }
      globalDate.sumPrice = sum * selectedDateGlobal['amountDays'];
      setSelectedDateGlobal(globalDate)
      sum = 0;

   }

   const laeveSize = (option) => {
      setChangeChoise(true)
      setHideSelectionBrend(true)
      setSelectedOptionSize(option)
      if (option === 'All') {
         setFinalSorting(props.selectedTypeOfBike)
         setHideSelectionBrend(false)
         setSelectedOptionSize(bikesFrameSize[0])
         setSelectedOptionBrend(bikesFrameSize[0])
      } else {
         let result = props.selectedTypeOfBike.filter(item => item.size === option)
         setFinalSorting(result)
         setFirstSorting(result)
      }
   }

   const laeveBrend = (option) => {
      setSelectedOptionBrend(option)
      if (option === 'All') {
         setFinalSorting(firstSorting)
      } else {
         let result = firstSorting.filter(item => item.brend === option)
         setFinalSorting(result)
      }
   }

   

   return (
      <div className='rentalSelectedBike__wrapper'>
         <div className="rentalSelectedBike__body">
            <div className="rentalSelectedBike__search">
               <div className="rentalSelectedBike__search-item">
                  <div className="rentalSelectedBike__sizeFrame rentalSelectedBike__search-type">
                     <div className="rentalSelectedBike__signature signature">Frame size</div>
                     <MyDropdownBikeSize
                        bikesFrameSize={bikesFrameSize}
                        selectedOptionSize={selectedOptionSize}
                        laeveSize={laeveSize}
                     />
                  </div>
               </div>
               <div className="rentalSelectedBike__search-item">
                  <div className="rentalSelectedBike__brend rentalSelectedBike__search-type">
                     <div className="rentalSelectedBike__signature signature">Brend</div>
                     <MyDropdownBrend
                           hideSelectionBrend={hideSelectionBrend}
                           bikesBrend={bikesBrend}
                           selectedOptionBrend={selectedOptionBrend}
                           laeveBrend= {laeveBrend}
                        />
                     <div
                        className={ hideSelectionBrend ? "rentalSelectedBike__hideSelection" : "rentalSelectedBike__hideSelection-active"}
                     ></div>
                  </div>
               </div>
               
            </div>
            <div className="rentalSelectedBike__options">
               {finalSorting.map((item, index) => (
                  <div
                     className="rentalSelectedBike__card"
                     key={index}
                  >
                     <RentalBikeCard
                        takeBikeNumber={takeBikeNumber}
                        number={item.number}
                        type={item.type}
                        size={item.size}
                        brend={item.brend}
                        image={item.image}
                        typeBike={item.typeBike}
                        fullName={item.fullName}
                        price={item.price}
                        state={item.state}
                     />
                  </div>
               ))} 
            </div>
            <div className="rentalSelectedBike__select">
               <Link to={rentalRequestRoute[0].path}>
                  <MyButton
                     style={{ fontSize: '20px', fontWeight: '700' }}
                     onClick={addSelectedBike}
                  >
                     Next
                  </MyButton>
               </Link>
            </div>
         </div>
      </div>
      
   );
}
export default RentalSelectedBike;